import { FieldParameter } from "@fartherfinance/frontend/api/TaskWorkflows/Types";
import { matchFieldDisplay } from "@fartherfinance/frontend/api/TaskWorkflows/utils/patternMatching";

import FormComboboxField from "@src/sharedComponents/Forms/FormComboboxField";
import FormDateField from "@src/sharedComponents/Forms/FormDateField";
import FormDropdownField from "@src/sharedComponents/Forms/FormDropdownField";
import FormRadioField from "@src/sharedComponents/Forms/FormRadioField";
import FormTextareaField from "@src/sharedComponents/Forms/FormTextareaField";
import FormTextField from "@src/sharedComponents/Forms/FormTextField";

type FieldComponent = React.ComponentType<any>;

export function getFieldComponent(
  fieldParameter: FieldParameter
): FieldComponent {
  // Use pattern matching for FieldParameter - new unified approach
  return matchFieldDisplay(fieldParameter, {
    SelectField: (display) =>
      display.multi
        ? (FormComboboxField as FieldComponent)
        : (FormDropdownField as FieldComponent),

    InputField: (display) =>
      display.multiline
        ? (FormTextareaField as FieldComponent)
        : (FormTextField as FieldComponent),

    SelectAccountField: (display) =>
      display.multi
        ? (FormComboboxField as FieldComponent)
        : (FormDropdownField as FieldComponent),

    DueDateInputField: () => FormDateField as FieldComponent,

    RadioButtonField: () => FormRadioField as FieldComponent,

    Default: () => {
      console.warn(
        "[FormEngine:FieldRegistry] Unknown field type, falling back to TextField"
      );
      return FormTextField as FieldComponent;
    },
  });
}
